import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Spotlight from "@/components/landing/Spotlight";
import Subdomains from "@/components/landing/Subdomains";
import Manifesto from "@/components/landing/Manifesto";
import Destinations from "@/components/landing/Destinations";
import B2BGrid from "@/components/landing/B2BGrid";
import LeadCapture from "@/components/landing/LeadCapture";
import Footer from "@/components/landing/Footer";
import ChatWidget from "@/components/landing/ChatWidget";
import AdminPage from "@/pages/AdminPage";

function Landing() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Spotlight />
        <Subdomains />
        <Manifesto />
        <Destinations />
        <B2BGrid />
        <LeadCapture />
      </main>
      <Footer />
      <ChatWidget />
    </>
  );
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, anchors: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-ink font-sans text-cream antialiased selection:bg-gold selection:text-on-gold">
      <Toaster theme="dark" position="bottom-right" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
